module.exports = __webpack_public_path__ + "static/media/hero-banner-mob.97fd618c.png";